"use client";

/**
 * A screen that broke shows this instead of going blank, and the rest of the
 * app (the connection the assistant and exports work through) keeps running.
 */

import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function ScreenError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		console.error(error);
	}, [error]);
	return (
		<div className="bg-background grid min-h-screen place-items-center p-6">
			<div className="flex max-w-sm flex-col items-center gap-4 text-center">
				<h1 className="text-lg font-semibold">משהו השתבש במסך הזה</h1>
				<p className="text-muted-foreground text-sm leading-relaxed">
					העבודה שמורה. אפשר לנסות שוב, או לחזור לפרויקטים.
				</p>
				<div className="flex gap-2">
					<Button onClick={reset}>לנסות שוב</Button>
					<Button variant="raised" asChild>
						<Link href="/">לפרויקטים שלי</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
